import {Component, Input, ComponentFactoryResolver, ViewContainerRef} from '@angular/core';
import {ProductListComponent} from '../product-list/product-list.component';
import {ToolsComponent} from '../tools/tools.component';
import {FenceBlock} from "../../services/message.parser.service";

// Import other custom components as needed

@Component({
  selector: 'app-fence-block',
  template: '<ng-container #container></ng-container>'
})
export class FenceBlockComponent {
  @Input() set block(value: any) {
    if (value) {
      this.loadComponent(value);
    }
  }

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private viewContainerRef: ViewContainerRef
  ) {
  }

  private loadComponent(block: FenceBlock): void {
    this.viewContainerRef.clear();



    // Map block types to components
    const componentMap: { [key: string]: any } = {
      'product_list': ProductListComponent,
      'tools': ToolsComponent,
      // Add more component mappings here
    };

    const componentType = componentMap[block.type];

    if (componentType) {
      const factory = this.componentFactoryResolver.resolveComponentFactory(componentType);
      const componentRef = this.viewContainerRef.createComponent(factory);
      (componentRef.instance as any).data = block.content;
    } else {
      // Fallback for unknown block types
      this.viewContainerRef.element.nativeElement.textContent = block.rawContent;
    }
  }
}
